import React, { useState } from "react";
import { Box, Card, LinearProgress, Typography } from "@mui/material";
import DashboardPanelHeader from "components/DashboardPanelHeader";
import { enterpriseTokens, overviewChartPalette } from "styles/theme";
import EhsFindingList from "./ehsFindingListPopup";

const HseFindings = ({ data }) => {
    const [isPopup, setIsPopup] = useState(false);
    const [rowData, setRowData] = useState(null);
    const open = Number(data?.findingTracker?.openHSEFindings) || 0;
    const closed = Number(data?.findingTracker?.closedHSEFinding) || 0;
    const total = open + closed;
    const closure = total > 0 ? (closed / total) * 100 : 0;
    const rows = [
        { label: "Open findings", value: open, color: overviewChartPalette.coral, filter: "Open" },
        { label: "Resolved findings", value: closed, color: overviewChartPalette.teal, filter: "Closed" },
    ];

    const handleClick = (status) => {
        setRowData({ StatusOfCompliance: status });
        setIsPopup(true);
    };

    return (
        <Card elevation={0} sx={{ height: "100%", border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px", overflow: "hidden" }}>
            <DashboardPanelHeader eyebrow="Corrective action" title="HSE Finding Resolution" subtitle="Compare open observations with findings already resolved." />
            <Box sx={{ p: 1.5 }}>
                <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between" }}>
                    <Box><Typography sx={{ fontSize: "30px", lineHeight: "36px", fontWeight: 700, color: enterpriseTokens.navy }}>{total}</Typography><Typography sx={{ fontSize: "11px", color: enterpriseTokens.muted }}>Total findings</Typography></Box>
                    <Box sx={{ textAlign: "right" }}><Typography sx={{ fontSize: "20px", fontWeight: 700, color: overviewChartPalette.teal }}>{closure.toFixed(0)}%</Typography><Typography sx={{ fontSize: "10px", color: enterpriseTokens.muted }}>Resolution rate</Typography></Box>
                </Box>
                <Box sx={{ mt: 2, display: "grid", gap: 1.5 }}>
                    {rows.map((item) => {
                        const share = total > 0 ? (item.value / total) * 100 : 0;
                        return <Box key={item.label} onClick={() => handleClick(item.filter)} sx={{ cursor: "pointer" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}><Typography sx={{ fontSize: "12px", fontWeight: 600, color: enterpriseTokens.slate }}>{item.label}</Typography><Typography sx={{ fontSize: "12px", fontWeight: 700, color: item.color }}>{item.value}</Typography></Box>
                            <LinearProgress variant="determinate" value={share} sx={{ height: 8, borderRadius: 0, backgroundColor: "#E2E8F0", "& .MuiLinearProgress-bar": { borderRadius: 0, backgroundColor: item.color } }} />
                        </Box>;
                    })}
                </Box>
            </Box>
            {isPopup && <EhsFindingList header="HSE Finding List" open={isPopup} handleClose={() => setIsPopup(false)} filter={rowData} />}
        </Card>
    );
};

export default HseFindings;
